import { DisplayNote } from "ng/src/app/notes/note-display/note-display.model";
import { Note } from "ng/src/app/notes/shared/note.model";

export type NoteActionType = 'COMMENT' | 'DETAIL';

export interface NoteAction {
	label: string | ((note: DisplayNote<Note>) => string);
	icon: string | ((note: DisplayNote<Note>) => string);
	overflow?: boolean | ((note: DisplayNote<Note>) => boolean);
	display?: boolean | ((note: DisplayNote<Note>) => boolean);
	type: NoteActionType;
}

export class NoteAction {
	
	static get COMMENT(): NoteAction {
		return {
			label: 'Comment',
			icon: 'pi pi-comment',
			type: 'COMMENT'
		}
	}
	
	static get DETAIL(): NoteAction {
		return {
			label: 'Note Detail',
			icon: 'pi pi-bars',
			type: 'DETAIL'
		}
	}
	
	static defaultSet(): NoteAction[] {
		return [
			this.COMMENT,
			this.DETAIL
		]
	}
}